// extracted by mini-css-extract-plugin
module.exports = {"MainContentSection":"MainContentSection_MainContentSection__1JuVs","Title":"MainContentSection_Title__-G5H0"};